import axios from 'axios';
import { getToken, isUserLoggedIn, logOut } from '../../components/user/User';

export const API = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

API.interceptors.request.use(
  function (config) {
    if (isUserLoggedIn()) {
      config.headers.Authorization = 'Bearer ' + getToken();
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  function (response) {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      logOut();
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export const baseRequest = async ({
  method,
  path,
  data,
  baseUrl,
  contentType,
  responseType = 'json',
}) => {
  return API({
    method,
    baseURL: baseUrl || process.env.REACT_APP_BACKEND_URL,
    url: path,
    headers: {
      Accept: '*/*',
      'Content-Type': contentType || 'application/json',
    },
    responseType,
    ...(data && { data }),
  });
};
